import { services } from "../../../constants/services";
import { getByQuery } from "../../../utils/api";
import { IParamsBuilding, ResponseQ } from "../../../common/dtos/paginate.dto";

export const GetBuildingNameWithPaginationService = async (params: IParamsBuilding) => {
  const response = await getByQuery<any>(`${services.bookingReport}/getBuldingNames`, params);
    return response;
};

